<div class="mobilemenu" [ngClass]="{ 'mobilemenu--open': isOpen }">
  <div class="mobilemenu__backdrop" (click)="menuCategorias.close()"></div>
  <div class="mobilemenu__body">
    <div class="px-3 flex align-items-center" style="height: 50px">
      <i
        class="fa-regular fa-square-xmark fa-2x"
        style="cursor: pointer"
        (click)="menuCategorias.close()"
      ></i>
    </div>

    <div class="mobilemenu__content">
      <ul>
        <li
          class="mb-3 flex justify-content-between"
          *ngFor="let item of items"
        >
          <div class="text-truncate" (click)="menuCategorias.open(2, item)">
            {{ item.label | titlecase }}
          </div>
          <div style="width: 20px" (click)="menuCategorias.open(2, item)">
            <i class="fa-solid fa-chevron-right"></i>
          </div>
        </li>
      </ul>
      <ul style="border-top: 1px solid #fff; padding-top: 15px">
        <li
          class="mb-3 flex justify-content-between"
          *ngFor="let item of items_oficial"
        >
          <div class="text-truncate" (click)="menuCategorias.open(2, item)">
            {{ item.label | titlecase }}
          </div>
          <div style="width: 20px" (click)="menuCategorias.open(2, item)">
            <i class="fa-solid fa-chevron-right"></i>
          </div>
        </li>
      </ul>
    </div>
  </div>
</div>

<app-nivel2
  [items]="items"
  (seleccionado)="menuCategorias.close()"
></app-nivel2>
